/* useClickOutsideChartHandler.ts */

/* React */
import { useEffect } from "react";

/* d3.js */
import * as d3 from "d3";

/* Helper */
import { resetHighlight } from "src/components/charts/sankey-diagram/helper";

export const useClickOutsideChartHandler = (
  svgRef: React.RefObject<SVGSVGElement>
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const svgEl = svgRef.current;
      if (!svgEl) return;

      if (!svgEl.contains(event.target as Node)) {
        const svg = d3.select<SVGSVGElement, unknown>(
          svgEl
        );

        const diagramId = svg.attr("data-diagram-id");
        if (!diagramId) return;

        const activeFlowId = svg.attr(
          "data-active-flow-id"
        );
        const activeNodeId = svg.attr(
          "data-active-node-id"
        );

        // If there is an active flow or node, reset the highlighting
        if (activeFlowId || activeNodeId) {
          svg.attr("data-active-flow-id", null);
          svg.attr("data-active-node-id", null);
          resetHighlight(svg, diagramId);
        }
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener(
        "click",
        handleClickOutside
      );
    };
  }, [svgRef]);
};
